import { Action } from 'redux'
import { EVENT_CALCULATE, EVENT_LOAD_CALENDARS, EVENT_REMOVE_EXPIRED } from '../constants/ActionTypes'
import { Calendar } from '../model/Calendar'
import { Device } from '../model/Device'
import { Event } from '../model/Event'
import { ISettings } from '../services/hashParser'

export interface IActionLoadCalendars extends Action {
  type: typeof EVENT_LOAD_CALENDARS
  calendars: Calendar[]
  eventInterval: number
  settings: ISettings
  device: Device
}

export const loadCalendars = (
  calendars: Calendar[],
  eventInterval: number,
  settings: ISettings,
  device: Device,
): IActionLoadCalendars => ({
  type: EVENT_LOAD_CALENDARS,
  calendars,
  eventInterval,
  settings,
  device,
})

export interface IActionCalculateEvents extends Action {
  type: typeof EVENT_CALCULATE
  events: Event[]
}

export const calculateEvents = (events: Event[]): IActionCalculateEvents => ({
  type: EVENT_CALCULATE,
  events,
})

export interface IActionRemoveExpiredEvents extends Action {
  type: typeof EVENT_REMOVE_EXPIRED
}

export const removeExpiredEvents = (): IActionRemoveExpiredEvents => ({
  type: EVENT_REMOVE_EXPIRED,
})
